import styled from "styled-components"

export const Wrapper = styled.div`
  position:absolute;
  left:3%;
  right:3%;
  width:94%;
  height:25%;
  top:5%;  
`

export const Heading = styled.div`
  text-align:center;
  color:#f4ecb2;
  font-size:32px;
  font-family:arial, helvetica, sans-serif;
`

export const SubHeading = styled.div`
  text-align:center;
  color:white;
  font-size:20px;
  font-family:arial, helvetica, sans-serif;
`

export const GoldSpan = styled.span`
  color:#f4ecb2;
`